import {Component, Inject, ChangeDetectionStrategy} from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogClose } from "@angular/material/dialog";
import { MatButton } from '@angular/material/button';

@Component({
    selector: 'app-generic-dialog',
    templateUrl: './generic-dialog.component.html',
    styleUrls: ['./generic-dialog.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [MatButton, MatDialogClose]
})
export class GenericDialogComponent {
    constructor(
        @Inject(MAT_DIALOG_DATA) public data: {
            title: string;
            message: string;
            confirmText?: string;
            cancelText?: string;
        }
    ) {}
}
